import React from 'react';
import { Prefab } from '@gift/basic-scene-core/Prefab';
import { PrefabPickerField } from './PrefabPickerField';
import { PrefabPickerGrid } from './PrefabPickerGrid';
import styles from './PrefabPickerAccordion.module.scss';
import { Desktop } from '@gift/ui/components/breakpoints/Desktop';
import { useToggle } from '@gift/ui/hooks/useToggle';
import { Accordion } from '@gift/ui/components/accordion/Accordion';
import { AccordionField } from '@gift/ui/components/accordion/partials/AccordionField';
import { AccordionMenu } from '@gift/ui/components/accordion/partials/AccordionMenu';

export const PrefabPickerAccordion = ({
    title, prefabs, selectedPrefab, commit
}: Props) => {
    const [isOpen, toggleOpen] = useToggle(true);
    return (
        <Desktop>
            <Accordion active={isOpen}>
                <AccordionField onClick={toggleOpen} active={isOpen}>
                    {title}
                </AccordionField>
                <AccordionMenu active={isOpen} height={300} isExpandable className={styles.container}>
                    <PrefabPickerGrid
                        prefabs={prefabs}
                        selectedPrefab={selectedPrefab}
                        commit={commit} />
                </AccordionMenu>
            </Accordion>
        </Desktop>
    );
};

type Props = {
    title: string,
    prefabs: Prefab[],
    selectedPrefab: Prefab,
    commit: (prefab: Prefab) => void
};
